/* eslint-disable */
import React from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const VisitShareButton = ({ link, isRTL = false }) => {
  const handleShareSuccess = () => {
    Swal.fire({
      icon: "success",
      title: isRTL ? t("ui.linkCopied") : t("ui.linkCopied"),
      text: isRTL ? t("ui.linkCopiedHint") : t("ui.linkCopiedHint"),
      confirmButtonText: isRTL ? t("ship.ok") : t("ship.ok"),
      confirmButtonColor: "#7e5395",
      timer: 3000,
      timerProgressBar: true,
      position: "bottom-end",
      toast: true,
      showConfirmButton: false,
    });
  };

  const { t } = useTranslation();
  const shareSite = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: isRTL ? "اكتشف هذا الموقع" : "Check out this site",
          url: link,
        });
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(link);
        handleShareSuccess();
      } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = link;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        handleShareSuccess();
      }
    } catch (error) {
      console.error("Sharing failed:", error);
    }
  };

  return (
    <div
      className={`
        flex items-center
        bg-gradient-to-r from-[#5a2b73] to-[#6b3284]
        text-white
        rounded-full
        border-2 border-[#be97d4]
        shadow-lg shadow-purple-500/20
        hover:shadow-xl hover:shadow-purple-500/30
        transition-all duration-300 ease-in-out
        hover:scale-105
        backdrop-blur-sm
        relative
        overflow-hidden
        group
      `}
      style={{ zoom: "80%" }}
      dir={isRTL ? "ltr" : "rtl"}
     >
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

      {/* Share Button */}
      <button
        onClick={shareSite}
        className={`
          h-12 w-12
          bg-gradient-to-br from-[#be97d4] to-[#be97d4]
          border-2 border-[#be97d4]
          rounded-r-lg
          flex items-center justify-center
          transition-all duration-300 ease-in-out
          hover:scale-110
          shadow-md shadow-purple-400/30
          hover:shadow-lg hover:shadow-purple-400/50
          active:scale-95
          relative
          z-10
          group/share
        `}
        aria-label={isRTL ? t("navbar.try.shareLink") : t("navbar.try.shareLink")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#5a2b73"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="transition-transform duration-300 group-hover/share:rotate-12"
        >
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
          <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
        </svg>
      </button>

      {/* Visit Store Link */}
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={`
          h-12
          flex items-center gap-3
          px-6 py-3
          rounded-l-lg
          text-white
          font-medium
          transition-all duration-300 ease-in-out
          hover:bg-white/10
          hover:border-[#be97d4]
          active:scale-95
          relative
          z-10
          group/visit
        `}
      >
        <span className="text-sm font-semibold tracking-wide whitespace-nowrap">
          {t("sidebar.visitstore")}
        </span>
        <div className="flex items-center justify-center w-5 h-5 bg-white/20 rounded-full transition-all duration-300 group-hover/visit:bg-white/30 group-hover/visit:scale-110">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="transition-transform duration-300 group-hover/visit:translate-x-0.5"
            transform={isRTL ? "rotate(180)" : ""}
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </div>
      </a>
    </div>
  );
};

export default VisitShareButton;